import { listDevices, listCompanies, listBatches, createDevice, updateDevice, createCompany, createBatch,deleteDevice, deleteCompany, deleteBatch } from '@/services/inventory.service'
export default {
  namespaced: true,
  state: {
    devices: [],
    companies: [],
    batches: [],
    loading: false
  },
  mutations: {
    SET_DEVICES(state, devices) { state.devices = devices },
    SET_COMPANIES(state, companies) { state.companies = companies },
    SET_BATCHES(state, batches) { state.batches = batches },
    SET_LOADING(state, loading) { state.loading = loading },
    UPDATE_DEVICE(state, updatedDevice) {
      const index = state.devices.findIndex(d => d.mac === updatedDevice.mac)
      if (index !== -1) state.devices.splice(index, 1, updatedDevice)
    },
    ADD_COMPANY(state, companyName) {
      state.companies.push(companyName)
    },
    ADD_DEVICE(state, device) {
      state.devices.push(device)
    },
    ADD_BATCH(state, batch) {
      state.batches.push(batch)
    },
    REMOVE_DEVICE(state, mac) {
  state.devices = state.devices.filter(d => d.mac !== mac)
},
REMOVE_COMPANY(state, name) {
  state.companies = state.companies.filter(c => c !== name)
},
REMOVE_BATCH(state, number) {
  state.batches = state.batches.filter(b => b.number !== number)
},
  },
actions: {
  async loadDevices({ commit }) {
    const data = await listDevices()
    commit('SET_DEVICES', data)
  },
  async loadCompanies({ commit }) {
    const data = await listCompanies()
    commit('SET_COMPANIES', data)
  },
  async loadBatches({ commit }) {
    const data = await listBatches()
    commit('SET_BATCHES', data)
  },

  async addDevice({ dispatch }, device) {
    await createDevice(device)                  // ← calls the backend
    await dispatch('loadDevices')               // refresh the list
  },
  async updateDevice({ dispatch }, device) {
    await updateDevice(device.mac, device)      // ← calls the backend
    await dispatch('loadDevices')
  },

  async addCompany({ dispatch }, name) {
    await createCompany(name)                   // ← calls the backend
    await dispatch('loadCompanies')
  },
  async addBatch({ dispatch }, batch) {
    await createBatch(batch)                    // ← calls the backend
    await dispatch('loadBatches')
  },
  async deleteDevice({ commit }, mac) {
  await deleteDevice(mac)                     // calls backend
  commit('REMOVE_DEVICE', mac)                // remove from state locally
},
async deleteCompany({ commit }, name) {
  await deleteCompany(name)                   // calls backend
  commit('REMOVE_COMPANY', name)
},
async deleteBatch({ commit }, number) {
  await deleteBatch(number)                   // calls backend
  commit('REMOVE_BATCH', number)
},
},
  getters: {
    allDevices: state => state.devices,
    allCompanies: state => state.companies,
    allBatches: state => state.batches,
    deviceByMac: state => mac => state.devices.find(d => d.mac === mac),
    devicesByCompany: state => name => state.devices.filter(d => d.currentLocation === name),
    devicesByBatch: state => number => state.devices.filter(d => d.batch && d.batch.startsWith('Batch ' + number)),
    timelineForDevice: state => mac => getDeviceTimeline(mac)
  }
}